import React from "react";
import Name from "./Name/Name.js";
import Address from "./Address/Address.js";
import Directions from "./Directions/Directions.js";
import Prevention from "./Prevention/Prevention.js";
import AboutNII from "./AboutNII/AboutNII.js";
// import Information from "./Information/Information.js";
import Employees from "./Employees/Employees.js";
import Record from "./Record/Record.js";
import News from "./News/News.js";
import Mandatory from "./Mandatory/Mandatory.js";
// import Reviews from "./Reviews/Reviews.js";
import Map from "./Map/Map.js";
import GosuslugiBanner from "./Mandatory/Banner/GosuslugiBanner/GosuslugiBanner.js";
import AntiCorrup from "./Mandatory/Banner/Anti-corruption/Anti-corruption.js";

import useSEO from "../hooks/useSEO.js";
import seoConfig from "../hooks/seoConfig";

export default function Main() {
  useSEO(seoConfig.home);
  useSEO({
    title:
      "УрНИИДВИ – Уральский научно-исследовательский институт дерматовенерологии и иммунопаталогии",
    description:
      "Узнайте о деятельности УрНИИДВИ, исследованиях, клинике, образовании и услугах для пациентов.",
    keywords: "УрНИИДВИ, дерматовенерология, клиника инфекционных заболеваний",
  });

  return (
    <main className="main">
      <Name /> {/*Название*/}
      <News /> {/* Новости */}
      <Address /> {/* Адрес */}
      <Directions /> {/* Направления работ */}
      <Prevention /> {/* Недельники / профилактика */}
      <AboutNII /> {/* О нас */}
      {/* <Information /> Информационные блоки */}
      <Employees /> {/* Сотрудники */}
      <Record /> {/* Запись онлайн */}
      <Mandatory /> {/* Обязательные баннеры для министерства */}
      <GosuslugiBanner />
      {/* <Reviews /> Отзывы */}
      <AntiCorrup />
      <Map /> {/* Карта */}
    </main>
  );
}
